import { observable } from "mobx";
import { Type } from "class-transformer";
import OutgoingTransferCounterpartyBankAccountResponse from "./outgoingTransferCounterpartyBankAccountResponse";
import OutgoingTransferPaymentStatus from "./outgoingTransferPaymentStatus";
import RefundChargeResponse from "./refundChargeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingTransferPaymentResponse {
  id!: string;

  @observable
  variableSymbol?: number;

  @observable
  @Type(() => Date)
  postingDate?: Date;

  @observable
  @Type(() => Date)
  exportedDate?: Date;

  @observable
  messageForRecipient?: string;

  @observable
  @Type(() => OutgoingTransferCounterpartyBankAccountResponse)
  recipientBankAccount?: OutgoingTransferCounterpartyBankAccountResponse;

  @observable
  paidAmount!: number;

  @observable
  @Type(() => RefundChargeResponse)
  searchedCharge?: RefundChargeResponse;

  @observable
  status!: OutgoingTransferPaymentStatus;

  @observable
  isUnidentified!: boolean;

  @observable
  outgoingTransferReason?: string;
}
